import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-angle-expand",
  "use": "arrow-angle-expand-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-angle-expand\"><path d=\"M8.333 4.3c.209-.208.4-.667 0-1.067-.4-.4-.858-.208-1.066 0L3 7.5l4.267 4.267c.208.208.663.404 1.066 0 .404-.404.209-.859 0-1.067l-3.2-3.2 3.2-3.2z\" /><path d=\"M13.667 4.3c.208-.208.4-.667 0-1.067-.4-.4-.859-.208-1.067 0L8.333 7.5l4.267 4.267c.208.208.663.404 1.067 0 .403-.404.208-.859 0-1.067l-3.2-3.2 3.2-3.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol